// removed by extract-text-webpack-plugin
module.exports = {"root":"_2LF-h","nav":"_18kyb","navContainer":"Un2HS","extra":"_178DQ","logos":"_2GR9I","facebookButton":"_3yaPy"};


//////////////////
// WEBPACK FOOTER
// ../source/layouts/Footer/styles.css
// module id = 1223
// module chunks = 26